import {LocationData} from "./LocationData";
import location1 from '../../assets/img/location/location-1.jpg';
import location2 from '../../assets/img/location/location-2.jpg';
import location3 from '../../assets/img/location/location-3.jpg';
import location4 from '../../assets/img/location/location-4.jpg';
import location5 from '../../assets/img/location/location-5.jpg';
import location6 from '../../assets/img/location/location-6.jpg';
import location7 from '../../assets/img/location/location-7.jpg';
import location8 from '../../assets/img/location/location-8.jpg';
import location9 from '../../assets/img/location/location-9.jpg';
import location10 from '../../assets/img/location/location-10.jpg';
import location11 from '../../assets/img/location/location-11.jpg';
import location12 from '../../assets/img/location/location-12.jpg';
import location13 from '../../assets/img/location/location-13.jpg';
import location14 from '../../assets/img/location/location-14.jpg';
import location15 from '../../assets/img/location/location-15.jpg';
import location16 from '../../assets/img/location/location-16.jpg';
export  const Locations =  (): LocationData[] =>[
    {
        img: location1,
        alt: 'Наши локации'
    },
    {
        img: location2,
        alt: 'Наши локации'
    },
    {
        img: location3,
        alt: 'Наши локации'
    },
    {
        img: location4,
        alt: 'Наши локации'
    },
    {
        img: location5,
        alt: 'Наши локации'
    },
    {
        img: location6,
        alt: 'Наши локации'
    },
    {
        img: location7,
        alt: 'Наши локации'
    },
    {
        img: location8,
        alt: 'Наши локации'
    },
    {
        img: location9,
        alt: 'Наши локации'
    },
    {
        img: location10,
        alt: 'Наши локации'
    },
    {
        img: location11,
        alt: 'Наши локации'
    },
    {
        img: location12,
        alt: 'Наши локации'
    },
    {
        img: location13,
        alt: 'Наши локации'
    },
    {
        img: location14,
        alt: 'Наши локации'
    },
    {
        img: location15,
        alt: 'Наши локации'
    },
    {
        img: location16,
        alt: 'Наши локации'
    }
]